import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { BeraReportV2ResultStep } from '@/types/Bera';

import { StepKeyRow } from './StepKeyRow';
import { Divider, SectionTitle } from '../styles';
import { HeaderBar } from './styles';

const TITLE_GUTTER = 8;
const ROWS_GUTTER = 24;

interface StepSectionProps {
	step: BeraReportV2ResultStep;
	divider?: boolean;
}

export function StepSection({ step, divider = true }: Readonly<StepSectionProps>): JSX.Element {
	return (
		<Row gutter={[0, TITLE_GUTTER]}>
			<Col span={24}>
				<SectionTitle>{I18n.get(step.description)}</SectionTitle>
			</Col>
			<Col span={24}>
				<HeaderBar />
			</Col>
			<Col span={24}>
				<Row gutter={[0, ROWS_GUTTER]}>
					{step.stepKeys.map((stepKey) => (
						<Col key={stepKey.id} span={24}>
							<StepKeyRow step={step} stepKey={stepKey} />
						</Col>
					))}
					{divider && (
						<Col span={24}>
							<Divider />
						</Col>
					)}
				</Row>
			</Col>
		</Row>
	);
}
